import flagsJson from './feature-flag.json';

interface Flag {
  name: string;
  value: boolean;
}

const useFlag = (user: string, flagName: string): boolean => {
  const flags = JSON.parse(JSON.stringify(flagsJson));
  const flagNames = flags[user];
  const foundFlag = flagNames?.flags.find(
    (flag: Flag) => flag.name === flagName
  );
  return typeof foundFlag?.value === 'boolean'
    ? foundFlag?.value
    : foundFlag?.value === 'true';
};

export default useFlag;
